import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SubmittalService from '@/services/SubmittalService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: null,
    loading: false,
    error: null,
};

export const viewSubmittal = createAsyncThunk(
    'submittals/viewSubmittal',
    async (submittalId, { rejectWithValue }) => {
        try {
            const response = await SubmittalService.getSubmittal(submittalId);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const viewSubmittalSlice = createSlice({
    name: 'viewSubmittal',
    initialState: model,
    reducers: {},
    extraReducers: (builder) => {
        // view submittal
        builder.addCase(viewSubmittal.pending, (state) => {
            state.loading = true;
        }).addCase(viewSubmittal.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
        }).addCase(viewSubmittal.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = false;
        });
    },
});

export default viewSubmittalSlice.reducer;
